const api = process.env.REACT_APP_API_URL;

export const urls = {
	getDataSourcesByCountry: api + "Scenario/GetDatasourcesByCountry?",
	getScenario: api + "Scenario/GetScenario?",
	countryListUrl: api + "GetUserCountries?userid=",
	scDetails: api + "Scenario/GetScenarioDetails?",
	enums: api + "Scenario/GetAllEnum",
	searchCG: api + "Scenario/GetCustomerandCustomerGroup",
	searchPG: api + "Scenario/GetProductGroup?",
	CGRefData: api + "Scenario/GetCustomerGroupReferenceData?",
	saveScenario: api + "Scenario/SaveScenario",
	verifyScenario: api + "admin/VerifyScenario",
	submitScenario: api + "admin/SubmitScenario",
	cloneScenario: api + "Scenario/CloneScenario",
    editScDSAData: api + "Scenario/GetDataSourceAlignmentDataForScenario?",
	localForecastDataAlignmentCheck : api + 'Scenario/LocalForecastDataAlignmentCheck'
};

export const sizes = {
	w650: 650,
	w450: 450,
	w300: 300,
	w270: 270,
	w250: 250,
	w200: 200,
	w150: 150,
	h35: 35,
	h45: 45,
};

